import Box from '@mui/material/Box';
import { generatePath } from 'react-router-dom';

import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import {
	UnitOverviewPageUrl,
	drivelineviewPageUrl,
	productIndividualviewPageUrl,
} from 'main/routes/urls/RouteUrls';

import HomeLink from './HomeLink';

const RecentlyVisited = ({
	unitPublicId,
	unitTitle,
	drivelineId,
	chassisId,
	serialNumber,
}: {
	unitPublicId: string | null;
	unitTitle: string | null;
	drivelineId: number | null;
	chassisId: string | null;
	serialNumber: string | null;
}) => {
	const { trackApplicationInteraction } = useAdobeTracking();
	const unitIdConverted = unitPublicId ?? '0';
	const drivelineIdConverted = drivelineId ? drivelineId.toString() : '0';

	return (
		<Box>
			{/* this box is single recently visited row */}
			{unitPublicId ? (
				<>
					<HomeLink
						to={generatePath(UnitOverviewPageUrl, {
							unitId: unitIdConverted,
						})}
						label={unitTitle ? unitTitle.toString() : ''}
						onLinkClick={() =>
							void trackApplicationInteraction({
								action: 'click',
								stepName: 'HOME Recently Visited',
								selectedOptions: [
									{ attribute: 'type', value: 'unit' },
									{
										attribute: 'unitId',
										value: unitIdConverted,
									},
								],
							})
						}
					/>
					{drivelineId ? <>{'/'} </> : null}
				</>
			) : null}
			{drivelineId ? (
				<>
					<HomeLink
						to={generatePath(drivelineviewPageUrl, {
							id: drivelineIdConverted,
						})}
						label={chassisId ? chassisId?.toString() : ''}
						onLinkClick={() =>
							void trackApplicationInteraction({
								action: 'click',
								stepName: 'HOME Recently Visited',
								selectedOptions: [
									{ attribute: 'type', value: 'driveline' },
									{
										attribute: 'drivelineId',
										value: drivelineIdConverted,
									},
									{
										attribute: 'chassisId',
										value: chassisId ?? '',
									},
								],
							})
						}
					/>
					{serialNumber ? <>{'/'} </> : null}
				</>
			) : null}

			{serialNumber ? (
				<HomeLink
					to={generatePath(productIndividualviewPageUrl, {
						serialnumber: serialNumber,
						section: '',
					})}
					label={serialNumber ? serialNumber.toString() : ''}
					onLinkClick={() =>
						void trackApplicationInteraction({
							action: 'click',
							stepName: 'HOME Recently Visited',
							selectedOptions: [
								{
									attribute: 'type',
									value: 'productIndividual',
								},
								{
									attribute: 'serialNumber',
									value: serialNumber,
								},
							],
						})
					}
				/>
			) : null}
		</Box>
	);
};

export default RecentlyVisited;
